import { render, staticRenderFns } from "./SOV2.vue?vue&type=template&id=6c0c2f18&scoped=true"
import script from "./SOV2.vue?vue&type=script&lang=js"
export * from "./SOV2.vue?vue&type=script&lang=js"
import style0 from "./SOV2.vue?vue&type=style&index=0&id=6c0c2f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0c2f18",
  null
  
)

export default component.exports